<template>
  <div>
    <v-progress-linear v-if="$apollo.loading" indeterminate />
    <v-row v-else>
      <v-col>
        <metric-card label="Coach Chats with inactive staff members" :total="chats.length" />

        <vue-json-to-csv :json-data="dataString" :csv-title="`${$moment().format('YYYY_MM_DD')}_chats_inactive_staff`">
          <v-btn class="mt-2">
            Download CSV
          </v-btn>
        </vue-json-to-csv>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { decodeId } from "@/lib/string";
import { CHATS_INACTIVE_STAFF } from "@/graphql/queries/chat";
import VueJsonToCsv from "vue-json-to-csv";
import MetricCard from "@/components/shared/MetricCard";

export default {
  name: "ChatsInactiveStaff",
  components: {
    MetricCard,
    VueJsonToCsv,
  },
  data() {
    return {
      chats: [],
      loadingCSV: false,
      dataString: "",
    };
  },
  apollo: {
    chats: {
      query: CHATS_INACTIVE_STAFF,
      variables() {
        return {
          chatType: "COACH",
        };
      },
      update(data) {
        this.dataString = data.chatsInactiveStaff.map((item) => {
          const inactiveStaffUsers = item.users.filter((el) => el.isStaff && !el.isActive);
          let inactiveStaffString;
          if (inactiveStaffUsers) {
            inactiveStaffString = inactiveStaffUsers.map((item) => {
              return `${item.firstName} ${item.lastName}`;
            });
          }

          return {
            id: decodeId(item.id),
            title: item.title,
            type: item.type,
            adminLink: `https://admin.jeff.fitness/admin/chat/chat/${decodeId(item.id)}/change/`,
            inactiveStaffUsers: inactiveStaffString ? inactiveStaffString.join(":") : "",
          };
        });
        return data.chatsInactiveStaff;
      },
    },
  },
};
</script>
